export default function TrainingFormats() {
  const formats = [
    { icon: 'ri-building-2-line', title: 'Очный корпоративный тренинг', desc: 'Двухдневный интенсив в вашем офисе или на внешней площадке. Полное погружение команды, максимальная концентрация.' },
    { icon: 'ri-computer-line', title: 'Онлайн-формат', desc: 'Живые сессии через видеосвязь с демонстрацией экрана. Разбор переписок и совместная работа в реальном времени.' },
    { icon: 'ri-stack-line', title: 'Модульная программа', desc: 'Серия занятий на 2–3 месяца. Между модулями — домашние задания и разбор новых переписок.' },
    { icon: 'ri-building-line', title: 'Корпоративная академия', desc: 'Долгосрочная программа развития: регулярное обучение, сопровождение и встраивание стандартов в бизнес-процессы.' },
    { icon: 'ri-user-voice-line', title: 'Сопровождение', desc: 'Посттренинговый аудит переписок, обратная связь в чате, корректировка стратегии.' },
    { icon: 'ri-gamepad-line', title: 'Практикумы', desc: 'Интенсивные сессии по разбору переписок: 4–6 часов глубокой работы с реальными диалогами.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-layout-line"></i>
            Выберите формат
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Форматы обучения
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            От интенсивного тренинга до долгосрочной программы — формат подбирается под задачи, бюджет и масштаб компании.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {formats.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-5 md:p-6 border border-gray-100 hover:border-teal-100 hover:bg-teal-50/30 transition-colors group">
              <div className="w-12 h-12 bg-teal-600/10 rounded-xl flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-teal-600/15 transition-colors">
                <i className={`${item.icon} text-teal-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}